import { render, staticRenderFns } from "./BulkRateChange.vue?vue&type=template&id=c00a899a&scoped=true"
import script from "./BulkRateChange.vue?vue&type=script&lang=js"
export * from "./BulkRateChange.vue?vue&type=script&lang=js"
import style0 from "./BulkRateChange.vue?vue&type=style&index=0&id=c00a899a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c00a899a",
  null
  
)

export default component.exports